export const namespace = 'playout';

export const Status = {
  INITIAL: 'initial',
  LOADING: 'loading',
  LOADED: 'loaded',
  ERROR: 'error'
};

export const ACTION_TYPES = {
  SET_LOADING_STATUS: `${namespace}/SET_LOADING_STATUS`,
  SET_CURRENT_UPLOAD_FILE_REF: `${namespace}/SET_CURRENT_UPLOAD_FILE_REF`,
  IMPORT_PLAYOUT_WITH_DATA_MAPPING: `${namespace}/IMPORT_PLAYOUT_WITH_DATA_MAPPING`,
  GET_PLAYOUT_DATA_OVERVIEW: `${namespace}/GET_PLAYOUT_DATA_OVERVIEW`,
  GET_UPDATED_PLAYOUT_DATA_OVERVIEW: `${namespace}/GET_UPDATED_PLAYOUT_DATA_OVERVIEW`,
  SET_PLAYOUT_OVERVIEW: `${namespace}/SET_PLAYOUT_OVERVIEW`,
  GET_PLAYOUT_DATA_SETTING: `${namespace}/GET_PLAYOUT_DATA_SETTING`,
  SET_PLAYOUT_DATA_SETTING: `${namespace}/SET_PLAYOUT_DATA_SETTING`,
  SAVE_PLAYOUT_DATA_SETTING: `${namespace}/SAVE_PLAYOUT_DATA_SETTING`,
  UPDATE_IMPORT_STATUS: `${namespace}/UPDATE_IMPORT_STATUS`,
  GET_PLAYOUT_STATIONS: `${namespace}/GET_PLAYOUT_STATIONS`,
  UPDATE_CURRENT_UPLOAD_DATA: `${namespace}/UPDATE_CURRENT_UPLOAD_DATA`,
  DOWNLOAD_PLAYOUT_FILE: `${namespace}/DOWNLOAD_PLAYOUT_FILE`,
  GET_JOB_STATUS_PLAYOUT: `${namespace}/GET_JOB_STATUS_PLAYOUT`,
  GET_SINGED_URI_PLAYOUT_ERROR:`${namespace}/GET_SINGED_URI_PLAYOUT_ERROR`,
  SAVE_SINGED_URI_PLAYOUT_ERROR: `${namespace}/SAVE_SINGED_URI_PLAYOUT_ERROR`,
  SET_LOADING_PLAYOUT_ERROR_STATUS: `${namespace}/SET_LOADING_PLAYOUT_ERROR_STATUS`,
  DOWNLOAD_ERROR_REPORT: `${namespace}/DOWNLOAD_ERROR_REPORT`,
  SET_PLAYOUT_SETTING_STATUS: `${namespace}/SET_PLAYOUT_SETTING_STATUS`,
}

export const setLoadingStatus = (status) => ({
  type: ACTION_TYPES.SET_LOADING_STATUS,
  payload:{
    status
  }
})

export const setPlayoutSettingStatus = (status) => ({
  type: ACTION_TYPES.SET_PLAYOUT_SETTING_STATUS,
  payload:{
    status
  }
})

export const setCurrentUploadFileRef = (file, uploadType) => ({
  type: ACTION_TYPES.SET_CURRENT_UPLOAD_FILE_REF,
  payload: {
    file,
    uploadType
  }
});

export const importPlayoutWithDataMapping = (fileInfo, uploadType) => ({
  type: ACTION_TYPES.IMPORT_PLAYOUT_WITH_DATA_MAPPING,
  payload : {
    fileInfo,
    uploadType
  }
});

export const getPlayoutOverview = (range) => ({
  type: ACTION_TYPES.GET_PLAYOUT_DATA_OVERVIEW,
  payload : {
    range
  }
});

export const getUpdatedPlayoutOverview = () => ({
  type: ACTION_TYPES.GET_UPDATED_PLAYOUT_DATA_OVERVIEW,
  payload : {}
});

export const setPlayoutOverview = (overviewList, range, totalRecords) => ({
  type: ACTION_TYPES.SET_PLAYOUT_OVERVIEW,
  payload: {
    range,
    overviewList,
    totalRecords
  }
});

export const getPlayoutSetting = () => ({
  type: ACTION_TYPES.GET_PLAYOUT_DATA_SETTING,
  payload : {}
});

export const setPlayoutSetting = (settings) => ({
  type: ACTION_TYPES.SET_PLAYOUT_DATA_SETTING,
  payload : {
    settings
  }
});

export const savePlayoutSetting = (settings) => ({
  type: ACTION_TYPES.SAVE_PLAYOUT_DATA_SETTING,
  payload : {
    settings
  }
});

export const updateImportStatus = (statusInfo) => ({
  type: ACTION_TYPES.UPDATE_IMPORT_STATUS,
  payload : {
    statusInfo
  }
});

export const getPlayoutStations = (stationIds) => ({
  type: ACTION_TYPES.GET_PLAYOUT_STATIONS,
  payload: {
    stationIds
  }
});

export const updateCurrentUploadData = (data) => ({
  type: ACTION_TYPES.UPDATE_CURRENT_UPLOAD_DATA,
  payload : {
    data
  }
});

export const downloadPlayoutFile = (ref, name, fileType) => ({
    type: ACTION_TYPES.DOWNLOAD_PLAYOUT_FILE,
    payload: {
      ref, name, fileType
    }
  });

export const getJobStatusPlayout = (data) => ({
  type: ACTION_TYPES.GET_JOB_STATUS_PLAYOUT,
  payload: {
    data
  }
});
export const getSingedUriForPlayoutError = (TDOId) => ({
  type: ACTION_TYPES.GET_SINGED_URI_PLAYOUT_ERROR,
  payload: {
    TDOId
    }
  });

export const saveSingedUriForPlayoutError = (uri) => ({
  type: ACTION_TYPES.SAVE_SINGED_URI_PLAYOUT_ERROR,
  payload: {
    uri
  }
});

export const setLoadingPlayoutErrorStatus = (status) => ({
  type: ACTION_TYPES.SET_LOADING_PLAYOUT_ERROR_STATUS,
  payload:{
    status
  }
});

export const downloadErrorReport = (uri, name) => ({
  type: ACTION_TYPES.DOWNLOAD_ERROR_REPORT,
  payload:{
    uri,
    name
  }
})